<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card header="Matricular Funcionários em Cursos">
          <b-alert show variant="info">
            <i class="fa fa-info-circle mr-2"></i>
            Selecione uma empresa, os funcionários e o curso para realizar
            matrículas em massa
          </b-alert>

          <b-form @submit.prevent="handleEnroll">
            <b-row>
              <b-col md="6">
                <b-form-group label="Empresa">
                  <b-form-select
                    v-model="selectedCompany"
                    :options="companyOptions"
                    @change="loadEmployees"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Curso">
                  <b-form-select
                    v-model="selectedCourse"
                    :options="courseOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group label="Funcionários">
              <b-form-checkbox-group
                v-model="selectedEmployees"
                :options="employeeOptions"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="!canSubmit">
              <i class="fa fa-user-plus mr-2"></i>
              Matricular Selecionados
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getCourses, enrollStudent } from "@/api/ead";

export default {
  name: "MatricularFuncionarios",
  data() {
    return {
      selectedCompany: null,
      selectedCourse: null,
      selectedEmployees: [],
      courses: [],
      employees: [],
    };
  },
  computed: {
    companyOptions() {
      return [{ value: null, text: "Selecione uma empresa" }];
    },
    courseOptions() {
      const options = [{ value: null, text: "Selecione um curso" }];
      this.courses.forEach((course) => {
        options.push({ value: course._id, text: course.nome });
      });
      return options;
    },
    employeeOptions() {
      return this.employees.map((emp) => ({
        value: emp._id,
        text: `${emp.name} - ${emp.email}`,
      }));
    },
    canSubmit() {
      return this.selectedCourse && this.selectedEmployees.length > 0;
    },
  },
  mounted() {
    this.loadCourses();
  },
  methods: {
    async loadCourses() {
      try {
        const response = await getCourses();
        this.courses = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar cursos:", error);
      }
    },
    loadEmployees() {
      // Implementar busca de funcionários da empresa
      this.employees = [];
    },
    async handleEnroll() {
      this.$bvToast.toast("Funcionalidade em desenvolvimento", {
        title: "Informação",
        toastClass: "custom-toast custom-toast-info",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
    },
  },
};
</script>
